<template>
  <div class="search-detaile offer">
    <Search />
    <div class="breadcrumb-wrap">
      <div class="container">
        <v-breadcrumbs :items="breadcrumbs" />
      </div>
    </div>
    <div class="container">
      <div class="position">
        <div class="bg-white p-20">
          <div class="search-body">
            <div class="search-action">
              <v-container>
                <v-row>
                  <mq-layout mq="laptop">
                    <v-col cols sm="2" md>
                      <a @click="showBlock = !showBlock" class="btn-column-list">
                        <v-icon x-large v-if="showBlock">mdi-view-list</v-icon>
                        <v-icon x-large v-else>mdi-view-module</v-icon>
                      </a>
                    </v-col>
                  </mq-layout>
                  <v-col class="text-right">
                    <router-link
                      active-class="active"
                      :to="$i18nRoute({ name: 'offer-create' })"
                      class="btn-post-offer"
                    >
                      <i class="pro-icon-edit-2"></i> {{ $t("Разместить предложение") }}
                    </router-link>
                  </v-col>
                </v-row>
              </v-container>
            </div>
            <div class="search-result">
              <div>
                <div class="search-result-body">
                  <mq-layout mq="laptop">
                    <div class="type-column">
                      <v-simple-table v-if="!showBlock">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <td
                                v-for="(item, index) in headerTable"
                                :key="index"
                              >
                                <Sorting
                                  v-if="item.sorting"
                                  :item="item"
                                  :filterable="item.filterable"
                                  :currentOrderKey="orderBy"
                                  @order="sortData($event)"
                                  @filter="sortingFilterHandler($event)"
                                  @cancelSorting="cancelSorting()"
                                />
                                <span v-else>
                                  {{ item.name }}
                                </span>
                              </td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="offer in offers" :key="offer.id">
                              <td>
                                <router-link
                                  :title="offer.title"
                                  active-class="active"
                                  :to="$i18nRoute({
                                    name: 'offer-view',
                                    params: { id: offer.id }
                                  })"
                                  :key="offer.id"
                                >
                                  {{ offer.title }}
                                </router-link>
                              </td>
                              <td>
                                {{ offer.user_id.second_name }}
                                {{ offer.user_id.first_name }}
                              </td>
                              <td>
                                <div class="analytics">
                                  <span class="views">
                                    <i class="pro-icon-eye"></i>
                                    {{ offer.views ? offer.views : 0 }}
                                  </span>
                                  <span class="comments">
                                    <i class="pro-icon-like"></i>
                                    {{ getProsCount(offer.offer_votes) }}
                                  </span>
                                  <span class="messages">
                                    <i class="pro-icon-dislike"></i>
                                    {{ getConsCount(offer.offer_votes) }}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <span v-if="offer.category">
                                  {{ offer.category.transName }}
                                </span>
                              </td>
                              <td>
                                {{
                                  new Date(offer.created_at) | dateFormat('DD.MM.YYYY')
                                }}
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                      <div class="columns-item" v-else>
                        <v-row>
                          <v-col cols md="4" v-for="offer in offers" :key="offer.id">
                            <div class="project-type">
                              <div v-if="offer.category">
                                {{ offer.category.transName }}
                              </div>
                            </div>
                            <div class="npa-title">
                              <router-link
                                :title="offer.title | strippedContent"
                                active-class="active"
                                :to="$i18nRoute({ name: 'offer-view', params: { id: offer.id } })"
                                :key="offer.id"
                              >
                                {{ offer.title | splitTextIntoLines(2, 30) }}
                              </router-link>
                            </div>
                            <div class="npa-dev">
                              {{ offer.user_id.second_name }}
                              {{ offer.user_id.first_name }}
                            </div>
                            <div class="date-period">
                              {{
                                new Date(offer.created_at) | dateFormat('DD.MM.YYYY')
                              }}
                            </div>
                            <div class="npa-analitics">
                              <div class="analytics">
                                <span class="views">
                                  <i class="pro-icon-eye"></i>
                                  {{ offer.views ? offer.views : 0 }}
                                </span>
                                <span class="comments">
                                  <i class="pro-icon-like"></i>
                                  {{ getProsCount(offer.offer_votes) }}
                                </span>
                                <span class="messages">
                                  <i class="pro-icon-dislike"></i>
                                  {{ getConsCount(offer.offer_votes) }}
                                </span>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </mq-layout>
                  <mq-layout mq="mobile">
                    <div class="columns-item">
                        <v-row>
                          <v-col cols md="4" v-for="offer in offers" :key="offer.id">
                            <div class="project-type">
                              <div v-if="offer.category">
                                {{ offer.category.transName }}
                              </div>
                            </div>
                            <div class="npa-title">
                              <router-link
                                :title="offer.title | strippedContent"
                                active-class="active"
                                :to="$i18nRoute({ name: 'offer-view', params: { id: offer.id } })"
                                :key="offer.id"
                              >
                                {{ offer.title | splitTextIntoLines(2, 30) }}
                              </router-link>
                            </div>
                            <div class="npa-dev">
                              {{ offer.user_id.second_name }}
                              {{ offer.user_id.first_name }}
                            </div>
                            <div class="date-period">
                              {{
                                new Date(offer.created_at) | dateFormat('DD.MM.YYYY')
                              }}
                            </div>
                            <div class="npa-analitics">
                              <div class="analytics">
                                <span class="views">
                                  <i class="pro-icon-eye"></i>
                                  {{ offer.views ? offer.views : 0 }}
                                </span>
                                <span class="comments">
                                  <i class="pro-icon-like"></i>
                                  {{ getProsCount(offer.offer_votes) }}
                                </span>
                                <span class="messages">
                                  <i class="pro-icon-dislike"></i>
                                  {{ getConsCount(offer.offer_votes) }}
                                </span>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                  </mq-layout>
                </div>
                <div class="search-result-footer">
                  <p>{{ $t("Общее количество") }}: {{ paginationData.totalCount }}</p>
                </div>
              </div>
            </div>
            <v-pagination
              v-model="page"
              :length="paginationData.pagesCount"
              total-visible="10"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Search from '@/components/Search'
import Offer from '@/model/offer'
import { mapMutations } from 'vuex'
import {Trans} from "@/plugins/Translation"
import mixin from '@/plugins/mixin/mixin'
import Sorting from "@/components/app/Sorting"

export default {
  mixins: [mixin],
  components: {
    Search,
    Sorting
  },
  data: () => ({
    offers: [],
    search: {},
    orderBy: 'createdAt',
    orderDir: 'desc',
    parent: null,
    showBlock: false,
    refCategory: [],
    breadcrumbs: [],
    paginationData: {},
    page: 1,
  }),
  watch: {
    // при изменениях маршрута запрашиваем данные снова
    $route: 'fetchData',
    page () {
      this.searchOffer()
    }
  },
  computed: {
    headerTable() {
      const fields = [
        { name: this.$t('Наименование предложения'), key: 'title', sorting: true },
        { name: this.$t('Автор'), key: 'userId', sorting: true },
        { name: this.$t('Голоса'), sorting: true, keys: ['commentsCount', 'viewNumber', 'answersCount'], children: [
            { name: this.$t('Просмотры'), key: 'views' },
            { name: this.$t('За'), key: 'likeOfferVotes' },
            { name: this.$t('Против'), key: 'dislikeOfferVotes' }
          ]
        },
        { name: this.$t('Категории'), key: 'category', sorting: true, filterable: true, filterItems: this.refCategory},
        { name: this.$t('Дата'), key: 'createdAt', sorting: true },
      ]
      return fields
    }
  },
  metaInfo () {
    return {
      title: this.$i18n.t('OfferTitleSEO'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: this.$i18n.t('OfferDescriptionSEO'),
      }, {
        vmid: 'keywords',
        name: 'keywords',
        content: this.$i18n.t('OfferKeywordsSEO'),
      }]
    }
  },
  created() {
    this.fetchData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData() {
      this.setLoading(true)
      Offer.getOfferSearchFormData().then((response) => {
        this.refCategory = response.data.refCategory
        this.breadcrumbs = [
          { text: this.$i18n.t('Главная'), disabled: false, href: Trans.currentLocaleUrl + '/' }
        ]

        if (!this.parent) {
          this.parent = response.data.parentMenu
          const breadcrumb = {}
          breadcrumb.text = this.parent.transName
          breadcrumb.disabled = true
          this.breadcrumbs.push(breadcrumb)
        }

        this.setLoading(false)
        this.searchOffer()
      })
      .catch((error) => {
        console.log(error)
      })
    },
    getProsCount(arr) {
      return arr.filter((v) => v.voice_type.id === 1).length
    },
    getConsCount(arr) {
      return arr.filter((v) => v.voice_type.id === 2).length
    },
    searchOffer() {
      this.setLoading(true)
      this.search.page = this.page
      this.search.orderBy = this.orderBy
      this.search.orderDir = this.orderDir
      Offer.getOffers(this.search).then((response) => {
        this.offers = response.data.items
        this.paginationData = response.data.paginationData

        this.setLoading(false)
      })
    },
    resetSearchOffer() {
      this.search = {}
      this.$router.replace({query: null})
      this.page = 1
      this.orderBy = 'createdAt'
      this.orderDir = 'desc'
      this.searchOffer()
    },
    sortData(sort) {
      this.orderBy = sort.key
      this.orderDir = sort.value
      this.page = 1
      this.searchOffer()
    },
    sortingFilterHandler(filter) {
      this.search[filter.name] = filter.value
      this.searchOffer()
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    cancelSorting () {
      this.orderBy = 'createdAt'
      this.orderDir = 'desc'
      this.searchOffer()
    }
  }
}
</script>
